/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Due_HoursInputs */

const cs_form_due_hours = /** @type {(inputs: Form_Due_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termín za (hodiny)`)
};

const en_form_due_hours = /** @type {(inputs: Form_Due_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due in (hours)`)
};

/**
* | output |
* | --- |
* | "Due in (hours)" |
*
* @param {Form_Due_HoursInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_due_hours = /** @type {((inputs?: Form_Due_HoursInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Due_HoursInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_due_hours(inputs)
	return cs_form_due_hours(inputs)
});